import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaEye,
  FaRocket,
  FaMobileAlt,
  FaStar,
  FaCut,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const AffordableVideoEditingServicesInAlBarsha = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Affordable Video Editing Services in Al Barsha" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Quality on a Budget</Subheading>}
        heading={
          <Heading>
            Affordable <span tw="text-primary-500">Video Editing Services</span>{" "}
            in Al Barsha
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, our affordable video editing services in **Al
            Barsha** deliver professional, high-impact videos without breaking
            the bank. From social media clips to business promos, we craft
            polished content that elevates your brand.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1626447852944-a375e7629e3b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1580537659466-0a9bfa916a54?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1513258496099-48168024aec0?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Get Started"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Affordable Video Editing in Al Barsha"
        description="We provide cost-effective editing services with professional quality."
        cards={[
          {
            icon: <FaCut color="#ff5464" size={40} />,
            title: "Budget-Friendly",
            description: "High-quality edits at prices that fit your budget.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Engaging Visuals",
            description: "Polished videos that captivate your audience.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Turnaround",
            description: "Quick delivery to meet tight deadlines.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Platform-Ready",
            description: "Optimized for social media, websites, and ads.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted Service",
            description: "Al Barsha’s choice for affordable editing.",
          },
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Expert Editing",
            description: "Professional cuts, effects, and transitions.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How果たWe Work</Subheading>}
        heading="Our Affordable Video Editing Process"
        description={
          <Description>
            We deliver professional video edits through a streamlined,
            cost-effective process:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Understand your vision and budget.</li>
              <li>Review: Analyze your raw footage and goals.</li>
              <li>
                Editing: Craft a polished video with cuts, effects, and audio.
              </li>
              <li>Feedback: Incorporate your revisions for perfection.</li>
              <li>Finalization: Deliver a high-quality video ready for use.</li>
              <li>Support: Offer post-delivery assistance as needed.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1616469829581-77edf95863c9?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1540655037529-dec987208707?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1502086223501-7ea6ecd79368?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Video Editing Wins in Al Barsha"
        description="Our affordable edits have elevated brands across Al Barsha."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Social Media Boost",
            description: "Increased engagement with a budget-friendly promo.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Brand Impact",
            description: "Enhanced visibility for a local business video.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description: "96% approval from cost-conscious clients.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready for Affordable Edits?</Subheading>}
        heading="Affordable Video Editing in Al Barsha"
        description={
          <Description>
            Partner with MilaajBrandset for affordable video editing services in
            Al Barsha. Get professional, high-impact videos that fit your
            budget—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1574717024453-354056afd83e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1518135714426-c18f5ffb6f4d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1523741543316-beb7fc7023d8?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
